import { render } from "./mechanicAdd.vue?vue&type=template&id=504d513a&scoped=true&ts=true"
import script from "./mechanicAdd.vue?vue&type=script&lang=ts"
export * from "./mechanicAdd.vue?vue&type=script&lang=ts"

import "./mechanicAdd.vue?vue&type=style&index=0&id=504d513a&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-504d513a"]])

export default __exports__